import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import omit from 'transmute/omit';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import * as flowActions from 'automation-ui-canvas/actions/FlowActions';
import * as ReduxRequestStates from 'redux-request-state/requestStates';
import { getFlowRevision, getFlowRevisionRequestStatus } from 'automation-ui-canvas/selectors/flowSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withRevision(WrappedComponent) {
  class RevisionDecorator extends Component {
    constructor(...args) {
      super(...args);
      this.handleRequestFlowRevision = () => {
        const {
          requestFlowRevision,
          _flowId,
          _revisionId
        } = this.props;
        if (!this.isLoading() && _flowId && _revisionId) {
          requestFlowRevision({
            flowId: _flowId,
            revisionId: _revisionId
          });
        }
      };
    }
    componentDidMount() {
      this.handleRequestFlowRevision();
    }
    componentDidUpdate(prevProps) {
      const {
        _flowId: prevFlowId,
        _revisionId: prevRevisionId
      } = prevProps;
      const {
        _flowId,
        _revisionId
      } = this.props;
      if (_flowId !== prevFlowId || _revisionId !== prevRevisionId) {
        this.handleRequestFlowRevision();
      }
    }
    isLoading() {
      const {
        flowRevisionRequestStatus
      } = this.props;
      return flowRevisionRequestStatus === ReduxRequestStates.STARTED;
    }
    render() {
      const wrappedComponentProps = omit(['requestFlowRevision', '_flowId', '_revisionId'], this.props);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, wrappedComponentProps));
    }
  }
  const ConnectedRevisionDecorator = compose(withRouter, connect((state, {
    match,
    flowId,
    revisionId
  }) => {
    const {
      flowId: stringId,
      revisionId: stringRevisionId
    } = match.params;

    // Accept both props and router props. Default to router props if no manual ones are supplied
    const _flowId = Number(flowId) || Number(stringId);
    const _revisionId = Number(revisionId) || Number(stringRevisionId);
    const flowRevision = getFlowRevision(_flowId, _revisionId)(state);
    const flowRevisionRequestStatus = getFlowRevisionRequestStatus(state);
    return {
      _flowId,
      _revisionId,
      flowRevision,
      flowRevisionRequestStatus
    };
  }, {
    requestFlowRevision: flowActions.requestFlowRevision
  }))(RevisionDecorator);
  const componentName = getComponentName(WrappedComponent);
  ConnectedRevisionDecorator.displayName = `ConnectedRevisionDecorator(${componentName})`;
  attachWrappedComponent(ConnectedRevisionDecorator, WrappedComponent);
  return ConnectedRevisionDecorator;
}